import React from 'react';
import { withStyles, makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import Box from '@material-ui/core/Box';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

function createData(val, photosize, tax) {
  val = val.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  photosize = photosize.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  tax = tax.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  return { val, photosize, tax };
}

const keisaiRows = [
  createData('2L', '127 × 178', '500円'),
  createData('A4', '210 × 297', '1,000円'),
  createData('A3', '297 × 420', '3,000円'),
];
const kijitsukiRows = [
  createData('A4', '210 × 297¥nうちのアイドル', '2,000円'),
  createData('A4', '210 × 297', '3,000円'),
  createData('A3', '297 × 420', '5,000円'),
];
const memorialRows = [
  createData('A3¥nラミネート', '297 × 420¥nカバーなし', '1,000円'),
  createData('A3¥nラミネート', '297 × 420¥nカバーあり', '1,200円'),
];

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function PrintService() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            掲載写真・紙面プリントサービスのご案内
          </Typography>
          　デーリー東北新聞社ではデーリー東北紙面に掲載された写真のプリントや、写真に記事・見出しなどを入れて再編集した「記事付き写真」、A4版に編集した「うちのアイドル」、誕生日や結婚記念日などご希望の日付の紙面を縮小コピーしラミネート加工した「メモリアル新聞」など写真・紙面の有料サービスを行っております。思い出づくりや掲載記念、贈り物などにご活用ください。<br/>
          <br/>
          　ご注文は下記のお問い合わせ・お申し込み先へお電話ください。<br/>
          　掲載写真、記事付き写真のご注文はネットでも承っております。<br/>
          　デリオンくらぶ会員は注文フォームから申し込むと、掲載写真、記事付き写真の割引が受けられます（メモリアル新聞は除く）。<br />
            2L版は100円引き、その他サイズは1割引。<br/>
          <br/>
          　写真（記事付き写真を含む）の提供は、本人や家族など掲載された写真（人物）と直接関係のある方に限らせていただきます。また、当社に著作権のない写真など提供できない場合もあります。デジタルデータの提供はできません。<br/>
          　なお、個人の私的使用以外の目的で使用される場合は、当社の許諾が必要となり、著作物二次使用料が発生する場合がありますので、ご注意願います。著作物二次使用についてはこちらをご覧ください。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/daily-right" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  著作物二次利用について
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            掲載写真
          </Typography>
          　本紙記者・カメラマンが撮影した紙面掲載写真を写真用紙にプリントしてお分けします。<br/>
          　掲載写真のご注文はネットでも承っております。<br/>
          <Box my={2}>
            <Paper>
              <Grid className="p-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={6}>
                  <Box p={1} textAlign="center">
                    <img src="/images/photoservice/photo-keisai.jpg" className="img-fluid" />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box p={1} textAlign="center">
                    <TableContainer component={Paper}>
                      <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">種類</StyledTableCell>
                            <StyledTableCell align="center">サイズ（ｍｍ）</StyledTableCell>
                            <StyledTableCell align="right">料金（税込）</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {keisaiRows.map(row => (
                            <StyledTableRow key={row.val}>
                              <StyledTableCell component="th" scope="row" align="center">
                                {row.val}
                              </StyledTableCell>
                              <StyledTableCell align="center">{row.photosize}</StyledTableCell>
                              <StyledTableCell align="right">{row.tax}</StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Grid>
              </Grid>
              <Box textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="https://delion-dt.com/" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                      デリオンくらぶ入会はこちら
                    </CustomButton>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    {/*
                    <CustomButton href="http://feature.daily-tohoku.co.jp/web2/company/form/keisai_photo/index.php" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                      掲載写真のご注文
                    </CustomButton>
                    */}
                    <CustomButton href="https://form.daily-tohoku.org/keisai-photo" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                      掲載写真のご注文
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
              <Box p={2} textAlign="left">
                <div class="fs90 text-danger line150 text-left">
                  ※出来上がりまで１週間ほどお時間をいただいております。<br/>
                  ※本社でのお渡しは代金引換、郵送の場合は郵便振込（振込用紙を同封します）となります。送料はお客様のご負担となります。<br/>
                </div>
              </Box>
            </Paper>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            記事付き写真
          </Typography>
          　本紙に掲載された写真に題字と記事・見出し・写真説明などを入れて再編集し、Ａ３サイズまたはＡ４サイズの写真用紙にプリントしたものです。<br/>
          <Box my={2}>
            <Paper>
              <Grid className="p-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={5}>
                  <Box p={1} textAlign="center">
                    <img src="/images/photoservice/photo-article.jpg" className="img-fluid" />
                  </Box>
                </Grid>
                <Grid item xs={12} md={7}>
                  <Box p={1} textAlign="center">
                    <TableContainer component={Paper}>
                      <Table className={classes.table} aria-label="customized table">
                        {/* <caption className="font-weight-bold text-danger">額はホワイト、ブラウン、グリーンの３色からお選びください。</caption> */}
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">種類</StyledTableCell>
                            <StyledTableCell align="center">サイズ（ｍｍ）</StyledTableCell>
                            <StyledTableCell align="right">料金（税込）</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {kijitsukiRows.map(row => (
                            <StyledTableRow key={row.val}>
                              <StyledTableCell component="th" scope="row" align="center">
                                {row.val}
                              </StyledTableCell>
                              <StyledTableCell align="center">{row.photosize}</StyledTableCell>
                              <StyledTableCell align="right">{row.tax}</StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Grid>
              </Grid>
              <Box p={2} textAlign="left">
                <div class="fs90 text-danger line150 text-left">
                  ※出来上がりまで２～３週間ほどお時間をいただいております。<br/>
                  ※本社でのお渡しは代金引換、郵送の場合は郵便振込（振込用紙を同封します）、宅配便利用の場合は代金引換となります。送料・代引手数料はお客様のご負担となります。<br/>
                </div>
              </Box>
            </Paper>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            メモリアル新聞
          </Typography>
          　誕生日や結婚記念日、入学・卒業、成人、還暦、金婚・銀婚式などいろいろな記念日のお祝いにお勧めです。<br/>
          　ご希望の日付のデーリー東北第１面とテレビ面をＡ３サイズ両面に縮小コピーしラミネート加工したものをお届けします。記念の品にぴったりの専用カバー付き商品と、お手軽なカバーなし商品をご用意しております。<br/>
          <Box my={2}>
            <Paper>
              <Grid className="p-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={5}>
                  <Box p={1} textAlign="center">
                    <img src="/images/photoservice/photo-memorial.jpg" className="img-fluid" />
                  </Box>
                </Grid>
                <Grid item xs={12} md={7}>
                  <Box p={1} textAlign="center">
                    <TableContainer component={Paper}>
                      <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">種類</StyledTableCell>
                            <StyledTableCell align="center">サイズ（ｍｍ）</StyledTableCell>
                            <StyledTableCell align="right">料金（税込）</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {memorialRows.map(row => (
                            <StyledTableRow key={row.val}>
                              <StyledTableCell component="th" scope="row" align="center">
                                {row.val}
                              </StyledTableCell>
                              <StyledTableCell align="center">{row.photosize}</StyledTableCell>
                              <StyledTableCell align="right">{row.tax}</StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Grid>
              </Grid>
              <Box p={2} textAlign="left">
                <div class="fs90 text-danger line150 text-left">
                  ※出来上がりまで２～３週間ほどお時間をいただいております。<br/>
                  ※本社でのお渡しは代金引換、郵送の場合は郵便振込（振込用紙を同封します）、宅配便利用の場合は代金引換となります。送料・代引手数料はお客様のご負担となります。<br/>
                </div>
              </Box>
            </Paper>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ・お申し込み
          </Typography>
          <dl>
            <dt>デーリー東北新聞社　読者センター</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7105<br/>
              ※受付時間　午前９時30分～午後５時00分（平日のみ）
            </dd>
          </dl>
        </Box>

      </div>
    </div>
  );
}

export default PrintService;
